import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './BikeList.css'; // Import the CSS file

function BikeList() {
  const [bikes, setBikes] = useState([]);

  useEffect(() => {
    axios.get('https://cardealer-backend-shac.onrender.com/api/bikes')
      .then(response => setBikes(response.data))
      .catch(error => console.error(error));
  }, []);

  return (
    <div className="bike-list-container">
      <h2>Bike Listing</h2>
      <div className="bike-cards">
        {bikes.map((bike) => (
          <div key={bike._id} className="bike-card">
            <Link to={`/bikes/${bike._id}`} className="bike-link">
              <img src={bike.imageUrl} alt={`${bike.brand} ${bike.model}`} className="bike-image" />
              <div className="bike-info">
                <h3>{bike.brand} {bike.model}</h3>
                <div className="bike-tags">
                  <button className="tag-button">{bike.condition}</button>
                  <button className="tag-button">{bike.currentLocation}</button>
                  <button className="tag-button">Ksh{bike.price}</button>
                  <button className="tag-button">{bike.year}</button>
                  <button className="tag-button">{bike.tireSize}</button>
                  <button className="tag-button">{bike.availability ? 'Available' : 'Not Available'}</button>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BikeList;
